import get from 'lodash/get'

const hasAuthError = (error) => {
	const status = String(get(error, 'status', get(error, 'response.statusCode')))
	if (![ '410', '401', '424', '403' ].includes(status)) {
		return false
	}

	const message = get(error, 'body.message', get(error, 'response.body.message', get(error, 'response.body.error', '')))

	if (
		'403' === status &&
		message &&
		-1 === message.indexOf('authentication') &&
		-1 === message.indexOf('credentials')
	) {
		return false
	}

	return status
}
export default hasAuthError
